import axios from "axios";
import logistics from './logistics';
import conditions from './conditions';
import mycroftDocuments from './mycroft/mycroft-documents';
import upcomingEvents from './upcoming-events';
import log from './log';
import commissions from './commissions';
import shinkibaMain from './shinkiba/shinkiba-main';
import payments from './payments';
import { useKooiNavigation } from '@/pinia/KooiNavigation';
import { InvoiceMenus } from "../../helpers/Kooi/InvoiceStatusMenu";
import { OrderMenus } from "../../helpers/Kooi/OrderStatusMenu";
import { OfferMenus } from "../../helpers/Kooi/OfferStatusMenu";
import { DiffPurchaseMenus } from "../../helpers/Kooi/DiffPurchaseStatusMenu";
import { CustomsMenus } from "../../helpers/Kooi/CustomsStatusMenu";
import { PurchaseContractMenus } from "../../helpers/Kooi/PurchaseContractStatusMenus";
import { MailMenus } from "../../helpers/Kooi/MailStatusMenu";
import { ReleaseStatusMenus } from "../../helpers/Kooi/ReleaseStatusMenu";
import { PurchaseMenu } from "../../helpers/Kooi/PurchaseMenu";
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    id: 0,
    copy_data: null,
    policies: {

    },
    loaded: {
        offers: false,
        invoices: false,
        order: false,
        communication: false,
        releases: false,
        external: {
            orders: false,
        },
    },
    rebates: [],
    rebates_unchangeable: false,
    lockLogistics: false,
    presentUsers: [],
    unlocked: null,

    displayColumns: {
        purchases : [
            {
                key: "invoice_number",
                label: "invoice_number",
                display: true,
                type: 'function',
                clickFunction($event, component) {
                    component.$store.commit("kooi/switchEditMode", true);
                    component.$emit("table:edit", $event);
                },
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],

            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                key: "invoice_date",
                label: "invoice_date",
                display: true,
                type: "date",
                format: null
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                key: "invoice_due_date",
                label: "invoice_due_date",
                display: true,
                type: "date",
                format: null
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                key: "type",
                label: "type",
                display: true,
                function: function (data) { return 'labels.invoice.types.' + data; }
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                key: "total_brutto",
                label: "amount",
                align: "right",
                display: true,
                type: "decimal",
                digit: null,
                append:
                  {
                    sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                    key: "currency.iso_code",
                    label: "currency",
                    display: true
                },
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase"],
                key: "total_netto",
                label: "total_netto",
                align: "right",
                display: true,
                type: "decimal",
                digit: null,
                append:
                  {
                    sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                    key: "currency.iso_code",
                    label: "currency",
                    display: true
                },
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                key: "currency.symbol",
                label: "currency",
                display: true
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                key: "status",
                label: "status",
                display: true
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                key: "created_by.name",
                label: "created_by",
                display: true
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                key: "canceled_by.name",
                label: "canceled_by",
                display: true
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                key: "paid_date",
                label: "paid_date",
                display: true,
                type: "date",
                format: null
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                key: "paid_amount",
                label: "paid_amount",
                display: true,
                type: "decimal",
                digit: 2,
                format: null,
                can: "OOI:show_paied_amount",
                append:
                  {
                    sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                    key: "currency.iso_code",
                    label: "currency",
                    display: true
                },
            },
        ],
        // table prefixed with "labels.kooi.tables.{label}"
        invoices: [
            {
                key: "invoice_number",
                label: "invoice_number",
                display: true,
                type: 'function',
                clickFunction($event, component) {
                    component.$store.commit("kooi/switchEditMode", true);
                    component.$emit("table:edit", $event);
                },
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],

            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                key: "invoice_date",
                label: "invoice_date",
                display: true,
                type: "date",
                format: null
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                key: "invoice_due_date",
                label: "invoice_due_date",
                display: true,
                type: "date",
                format: null
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                key: "type",
                label: "type",
                display: true,
                function: function (data) { return 'labels.invoice.types.' + data; }
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                key: "total_brutto",
                label: "amount",
                align: "right",
                display: true,
                type: "decimal",
                digit: null,
                append:
                  {
                    sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                    key: "currency.iso_code",
                    label: "currency",
                    display: true
                },
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase"],
                key: "total_netto",
                label: "total_netto",
                align: "right",
                display: true,
                type: "decimal",
                digit: null,
                append:
                  {
                    sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                    key: "currency.iso_code",
                    label: "currency",
                    display: true
                },
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                key: "currency.symbol",
                label: "currency",
                display: true
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                key: "status",
                label: "status",
                display: true
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                key: "created_by.name",
                label: "created_by",
                display: true
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                key: "canceled_by.name",
                label: "canceled_by",
                display: true
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                key: "paid_date",
                label: "paid_date",
                display: true,
                type: "date",
                format: null
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                key: "paid_amount",
                label: "paid_amount",
                display: true,
                type: "decimal",
                digit: 2,
                format: null,
                can: "OOI:show_paied_amount",
                append:
                  {
                    sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase", "provision", "rebate"],
                    key: "currency.iso_code",
                    label: "currency",
                    display: true
                },
            },
        ],
        offers: [
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase"],
                key: "invoice_number",
                label: "offer_number",
                display: true,
                type: 'function',
                clickFunction($event, component) {
                    component.$store.commit("kooi/switchEditMode", true);
                    component.$emit("table:edit", $event);
                }
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase"],
                key: "invoice_date",
                label: "offer_date",
                display: true,
                type: "date",
                format: null
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase"],
                key: "total_brutto",
                label: "amount",
                align: "right",
                display: true,
                type: "decimal",
                digit: null,
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase"],
                key: "currency.symbol",
                label: "currency",
                display: true
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase"],
                key: "status",
                label: "status",
                display: true
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase"],
                key: "created_by.name",
                label: "created_by",
                display: true
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase"],
                key: "canceled_by.name",
                label: "canceled_by",
                display: true
            },
        ],
        orders: [
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase"],
                key: "invoice_number",
                label: "order_number",
                display: true,
                type: 'function',
                clickFunction($event, component) {
                    component.$store.commit("kooi/switchEditMode", true);
                    component.$emit("table:edit", $event);
                }
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase"],
                key: "invoice_date",
                label: "order_date",
                display: true,
                type: "date",
                format: null
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase"],
                key: "cancel_invoice_id",
                label: "cancellation",
                display: true,
                function: function (data) { if (data == true) { return 'labels.boolean.yes'; } return 'labels.boolean.no'; }
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust"],
                key: "total_brutto",
                label: "amount",
                align: "right",
                display: true,
                type: "decimal",
                digit: null
            },
            {
                sales_types: ["purchase"],
                key: "total_brutto",
                label: "amount",
                align: "right",
                display: true,
                type: "decimal",
                digit: null,
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase"],
                key: "total_netto",
                label: "total_netto",
                align: "right",
                display: true,
                type: "decimal",
                digit: null,
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase"],
                key: "currency.symbol",
                label: "currency",
                display: true
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase"],
                key: "status",
                label: "status",
                display: true
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase"],
                key: "created_by.name",
                label: "created_by",
                display: true
            },
            {
                sales_types: ["stock", "stock_trust", "commission_only", "direct", "direct_trust", "purchase"],
                key: "canceled_by.name",
                label: "canceled_by",
                display: true
            },
        ],
        mails: [
            {
                key: "last_read_at",
                label: "read",
                display: true,
                type: "unread",
            },
            {
                key: "data.subject",
                label: "subject",
                display: true
            },
            {
                key: "status",
                label: "status",
                display: true
            },
            {
                key: "outgoing_at",
                label: "outgoing_at",
                display: true,
                type: "datetime",
                format: null
            },
            {
                key: "sent_at",
                label: "sent_at",
                display: true,
                type: "datetime",
                format: null
            },
            {
                key: "last_read_at",
                label: "last_read_at",
                display: true,
                type: "datetime",
            },
            {
                key: "last_read_user.name",
                label: "last_read_by",
                display: true,
            },
        ],
        releases: [
            {
                key: "data.contract_number",
                label: "order_number",
                display: true
            },
            {
                key: "status",
                label: "status",
                display: true
            },
            {
                key: "created_by.name",
                label: "created_by",
                display: true
            },
            {
                key: "canceled_by.name",
                label: "canceled_by",
                display: true
            },
        ],
    },
    menuOptions: {
        offers: OfferMenus,
        diff_purchase_contract: DiffPurchaseMenus,
        customs: CustomsMenus,
        purchase_contract: PurchaseContractMenus,
        order: OrderMenus,
        invoices: InvoiceMenus,
        mails: MailMenus,
        releases: ReleaseStatusMenus,
        purchases: PurchaseMenu,
    },
    tables: {
        invoices: [

        ],
        offers: [

        ],
        mails: [

        ],
        releases: [

        ],
        orders: [

        ],
        purchases : [

        ],
    },
    order: {},
    release: {},
    kooi: {
        id: 0,
    },
    agent_provision_percentage: 0,
    customer: {},
    supplier: {},
    editDocument: {},
    editRelease: {},
    edit: false,
    external: {
        orders: {
            list: [],
            page: 0,
            take: 50,
            search: "",
            loading: true,
            clear: false,
        },
    },
    kooi_status_resource: null,
    kooiloaded: false,
    isSaving: 0,
    workingOn: {
        mail: [],
        invoices: [],
        order: [],
        offers: [],
        releases: [],
    },
    externalRelations: [],
    emailTemplates: [],
    elementsLoading: {
        invoices: [

        ],
        order: [

        ]
    }
})

// getters
const getters = {
    getTableList: (state) => (type) => {
        return state.tables[type];
    },
    getVolume: (state) => (type = undefined) => {
        var tmpVolume = 0;
        if (type == undefined) {
            let invoices = state.tables.invoices.filter(item => item.canceled_by == null);
            if (invoices.length > 0 && invoices[0] && invoices[0].data && invoices[0].data.internal_volume && invoices[0].data.internal_volume.netto) {
                return invoices[0].data.internal_volume.netto;
            }
            let orders = state.tables.orders.filter(item => item.canceled_by == null);
            if (orders.length > 0 && orders[0] && orders[0].data && orders[0].data.internal_volume && orders[0].data.internal_volume.netto) {
                return orders[0].data.internal_volume.netto;
            }
            if (state.tables.offers.length > 0 && state.tables.offers[0] && state.tables.offers[0].data && state.tables.offers[0].data.internal_volume && state.tables.offers[0].data.internal_volume.netto) {
                return state.tables.offers[0].data.internal_volume.netto;
            }
            let purchases = state.tables.purchases.filter(item => item.canceled_by == null);
            if (purchases.length > 0 && purchases[0] && purchases[0].data && purchases[0].data.internal_volume && purchases[0].data.internal_volume.netto) {
                return purchases[0].data.internal_volume.netto;
            }
            return 1;
        }

    },
    getWeight: (state) => (type = undefined) => {
        let tmpVolume = 0;
        if (type == undefined) {
               let invoices = state.tables.invoices.filter(item => item.canceled_by == null);
            if (invoices.length > 0 && invoices[0] && invoices[0].data && invoices[0].data.weight) {
                return invoices[0].data.weight;
            }
            let orders = state.tables.orders.filter(item => item.canceled_by == null);
            if (orders.length > 0 && orders[0] && orders[0].data && orders[0].data.weight && orders[0].data.weight) {
                return orders[0].data.weight;
            }
            if (state.tables.offers.length > 0 && state.tables.offers[0] && state.tables.offers[0].data && state.tables.offers[0].data.weight && state.tables.offers[0].data.weight) {
                return state.tables.offers[0].data.weight;
            }
            return 0;
        }
    },
    getBundleCount: (state) => (type = undefined) => {
        let tmp = 0;
        if (type == undefined) {
            let invoices = state.tables.invoices.filter(item => item.canceled_by == null);
            if (invoices.length > 0 && invoices[0] && invoices[0].data && invoices[0].data.positions) {
                for (let i in invoices[0].data.positions) {
                    {
                        tmp += invoices[0].data.positions[i]?.shinkiba?.quantity ?? 0;
                    }
                }
                return tmp;
            }
            let orders = state.tables.orders.filter(item => item.canceled_by == null);
            if (orders.length > 0 && orders[0] && orders[0].data && orders[0].data.positions) {
                for (let i in orders[0].data.positions) {
                    {
                        tmp += orders[0].data.positions[i]?.shinkiba?.quantity ?? 0;
                    }
                }
                return tmp;
            }
            if (state.tables.offers.length > 0 && state.tables.offers[0] && state.tables.offers[0].data && state.tables.offers[0].data.positions) {
                for (let i in state.tables.offers[0].data.positions) {
                    {
                        tmp += state.tables.offers[0].data.positions[i]?.shinkiba?.quantity ?? 0;
                    }
                }
                return tmp;
            }
            return 0;
        }
    },
    getSupplier: (state) => {
        return state.supplier;
    },
    kooiTabNavigationAllowed: (state) => () => {
        if (state.kooi &&
            (state.kooi.sales_type == "stock" || state.kooi.sales_type == "stock_trust" || state.kooi.sales_type == "direct" || state.kooi.sales_type == "direct_trust") &&
            state.kooi.data &&
            state.kooi.data.company &&
            state.kooi.data.company.id > 0 &&
            state.kooi.data.company.terms &&
            state.kooi.data.company.terms.id > 0 &&
            state.kooi.data.supplier &&
            state.kooi.data.supplier.id > 0 &&
            state.kooi.data.supplier.terms &&
            state.kooi.data.supplier.terms.id > 0
        ) {
            return true;
        }
        else if (state.kooi &&
            state.kooi.sales_type == "purchase" &&
            state.kooi.data &&
            state.kooi.data.company &&
            state.kooi.data.company.id > 0 &&
            state.kooi.data.supplier &&
            state.kooi.data.supplier.id > 0
        ) {
            return true;
        }
        else if (state.kooi &&
            state.kooi.sales_type == "provision" &&
            state.kooi.data &&
            state.kooi.data.company &&
            state.kooi.data.company.id > 0 &&
            state.kooi.data.currency_sell > 0

        ) {
            return true;
        }

        else {
            return false;
        }
    }
}

// actions
const actions = {
    async loadExternalOrders({ commit, state, rootState }) {
        await axios.get(rootState.settings.url + "/api/v1/externaldata", { params: { page: state.external.orders.page, take: state.external.orders.take, search: state.external.orders.search } }).then((response) => {
            commit("setExternalOrders", response.data);
        })
    },
    async sendMailNow({ commit, state, rootState }, mail) {
        commit("workingOn", { set: true, id: mail.id, type: 'mail' });
        await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/emails/" + mail.id + "/sendNow").then(response => {
            commit("updateMail", response.data.data);
            commit("workingOn", { set: false, id: mail.id, type: 'mail' });
        })
    },
    async acceptDocument({ commit, state, rootState }, data) {
        return await axios.post(rootState.settings.url + "/api/v1/accept/" + data.subkey + "/" + data.document.id, { kooi_id: state.kooi.id, partial : data.partial}).then((response) => {
            const kooiNavigation = useKooiNavigation();
            if (response.data.offer != undefined && response.data.offer != null) {
                commit("updateoffers", response.data.offer);
                commit("loadDocument", { document: response.data.order, subkey: 'orders' });
                kooiNavigation.setTabActive(17);
                kooiNavigation.setSubkey("orders");
            }
            if (response.data.order != undefined && response.data.order != null) {
                commit("updateorders", response.data.order);
            }
            if (response.data.invoice != undefined && response.data.invoice != null) {
                commit("updateinvoices", response.data.invoice);
                kooiNavigation.setTabActive(4);
                kooiNavigation.setSubkey("invoices");
            }
            return response;
        });
    },
    async sendValidation({ commit, state, rootState }, data) {
        data.document.data.type;

        data.document.data.company.id;

        if (state.kooi.id == undefined) {
            data.document.kooi_id == null;
        } else {
            data.document.kooi_id = state.kooi.id;
        }

        var templateId = null;
        if (data.templateId != undefined) {
            templateId = data.templateId;
        }

        var showMail = false;
        if (data.showMail != undefined) {
            showMail = data.showMail;
        }
        return axios.post(rootState.settings.url + "/api/v1/validate_send/" + data.document.id, {
            kooi_id: state.kooi.id,
            templateId: templateId,
            showMail: showMail,
            send_to: data.send_to_overwrite ?? data.document.data.company.id,
            document_type: data.document.data.type,
            sub_type: data.document.type,
        })
    },
    async sendItem({ commit, state, rootState }, data) {
        data.document.data.type;

        data.document.data.company.id;

        if (state.kooi.id == undefined) {
            data.document.kooi_id == null;
        } else {
            data.document.kooi_id = state.kooi.id;
        }

        var templateId = null;
        if (data.templateId != undefined) {
            templateId = data.templateId;
        }

        var showMail = false;
        if (data.showMail != undefined) {
            showMail = data.showMail;
        }

        return await axios.post(rootState.settings.url + "/api/v1/send/" + data.document.id, {
            kooi_id: state.kooi.id,
            templateId: templateId,
            showMail: showMail,
            send_to: data.send_to_overwrite ?? data.document.data.company.id,
            document_type: data.document.data.type,
            sub_type: data.document.type,
        }).then((response) => {
            if (response.data?.document?.table) {
                commit("update" + response.data.document.table, response.data.document);
            }
            return response.data.data;
        });
    },
    async deleteMail({ commit, state, rootState }, data) {
        if (data.mail_id != undefined) {
            return await axios.post(rootState.settings.url + "/api/v1/deleteMail/" + data.mail_id).then((response) => {
                if (response !== true) return false;
                return true;
            });
        }
    },
    async saveDocument({ commit, state, rootState }, data) {
        commit("isSaving", +1);
        if (data.document != undefined) {

            if (data.document.id == undefined) {
                var id = 0;
            } else {
                var id = data.document.id;
            }
            if (state.kooi.id == undefined) {
                data.document.kooi_id == null;
            } else {
                data.document.kooi_id = state.kooi.id;
            }
            return await axios.put(rootState.settings.url + "/api/v1/create/" + data.subkey + "/" + id, data.document).then((response) => {
                if (data.subkey == "offers") {
                    commit("pushOffers", response.data);
                }
                if (data.subkey == "invoices") {
                    commit("pushInvoices", response.data);
                }
                if (data.subkey == "orders") {
                    commit("pushOrder", response.data);
                }
                if (data.subkey == "release") {
                    commit("pushRelease", response.data);
                }
                if(data.subkey == "purchase"){
                    console.log("purchase saved");
                }
                commit("isSaving", -1);
                return response;
            }).catch((error) => {
                commit("isSaving", -1);
                throw error;
            })
        }
        commit("isSaving", -1);
    },
    async destroyDocument({ commit, state, rootState }, data) {
        commit("isSaving", +1);
        if (data.id && data.id != 0 && data.type) {
            return await axios.delete(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/delete/" + data.type + "/" + data.id).then((response) => {
                commit("isSaving", -1);
                return response;
            })
        }
    },
    async saveKooi({ commit, state, rootState }) {
        commit("isSaving", +1);
        return await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/kooi/" + state.kooi.id, {
            kooi: state.kooi,
            agent_provision_percentage: state.agent_provision_percentage,
            logistics: state.logistics.list,
            conditions: state.conditions.list,
            commissions: state.commissions.list,
            rebates: state.rebates,
        })
            .then((response) => {
                commit("setKooi", response.data.data.kooi);
                commit("setPolicies", response.data.data.policies);
                commit("logistics/init", response.data.data.logistics);
                commit("logistics/tracking", response.data.data.tracking_links);
                commit("conditions/init", response.data.data.conditions);
                commit("setRebates", response.data.data.rebates);
                commit("setRebateStatus", response.data.data.rebates_unchangeable);
                commit("setAgentProvisionPercentage", response.data.data.agent_provision_percentage);
                commit("setLockLogistics", response.data.data.lockLogistics);
                commit("unlocked", response.data.data.unlocked);
                commit("isSaving", -1);
            }).catch((error) => {
                commit("isSaving", -1);
                throw error;
            })
    },
    async loadTable({ commit, state, rootState }, table) {
        return await axios.get(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/kooi/" + state.id + "/" + table, { params: { table_columns: state.displayColumns[table] } }).then((response) => {
            if (table == "offers") {
                commit("setOffers", response.data.data);
            }
            if (table == "orders") {
                commit("setOrders", response.data.data);
            }
            if (table == "invoices") {
                commit("setInvoices", response.data.data);
            }
            if (table == "releases") {
                commit("setReleases", response.data.data);
            }
        });
    },
    async loadKooi({ commit, state, rootState }) {
        commit("loaded", false);
        return await axios.get(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/kooi/" + state.id).then(
            // Slow function
            (response) => {
                commit("setOffers", response.data.data.offers);
                commit("setOrders", response.data.data.orders);
                commit("setMails", response.data.data.mails);
                commit("logistics/init", response.data.data.logistics);
                commit("logistics/tracking", response.data.data.tracking_links);
                commit("conditions/init", response.data.data.conditions);
                commit("commissions/init", response.data.data.commissions);
                commit("setInvoices", response.data.data.invoices);
                commit("setPurchases", response.data.data.purchases);
                commit("setReleases", response.data.data.releases);
                commit("setKooi", response.data.data.kooi);
                commit("setRebates", response.data.data.rebates);
                commit("setRebateStatus", response.data.data.rebates_unchangeable);
                commit("setLockLogistics", response.data.data.lockLogistics);
                commit("setPolicies", response.data.data.policies);
                commit("setAgentProvisionPercentage", response.data.data.agent_provision_percentage);
                commit("upcomingEvents/init", response.data.data.upcomingEvents);
                commit("log/init", response.data.data.history);
                commit("payments/init", response.data.data.payments);
                commit("payments/types_updating", response.data.data.payments_updating);
                commit("supplier", response.data.data.supplier),
                    commit("customer", response.data.data.customer),
                    commit("externalRelations", response.data.data.externalRelations);
                commit("setEMailTemplates", response.data.data.emailTemplates),
                    commit("kooiStatusResource", response.data.data.status_resource);
                commit("noElementLoading");
                commit("unlocked", response.data.data.unlocked);
                commit("loaded", true);
            }
        ).catch(function (error) {
            console.log(error);
        });
    },
    async printToPdf({ commit, state, rootState }, data) {
        await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/kooi/" + state.id + "/print", { type: data.type }).then(
            (response) => {
            });
    },

    async changeDocumentStatus({ commit, state, rootState }, data) {
        await axios.post(rootState.settings.url + "/api/v1/changeDocumentStatus/" + data.subkey + "/" + data.status + "/" + data.document.id, { kooi_id: state.kooi.id }).then((response) => {
            if (data.subkey == "orders") {
                commit("updateorders", response.data);
            }
            if (data.subkey == "invoices") {
                commit("updateinvoices", response.data);
            }

            if (data.subkey == "offers") {
                commit("updateoffers", response.data);
            }

            if (data.subkey == "releases") {
                commit("updateReleases", response.data);
            }
        });
    },
    async finalizeAndExport({ commit, state, rootState }, data) {
        return await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/finalizeandexport/" + data.subkey + "/" + data.status + "/" + data.document.id, { kooi_id: state.kooi.id }).then((response) => {
            return { status: "ok", data: response.data };
            // TODO: Edit document reload, damit die neusten daten dazu auch geladen werden
        });
    },

    async createRelease({ commit, state, rootState }, data) {
        return await axios.post(rootState.settings.url + "/api/v1/createRelease/" + data.document.id).then((response) => {
            commit("setReleases", response.data.allReleases);
            commit("loadRelease", { release: response.data.release, subkey: "releases" });
            commit("setRelease", { document: response.data.release });
            return response;
        });
    },
    async abortEmail({ commit, state, rootState }, data) {

        if (data.subkey === undefined) {
            data.subkey = "email";
        }

        await axios.put(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/emails/" + data.subkey + "/" + data.id + "/abortSending").then(response => {
            if (response.data?.document?.table) {
                commit("update" + response.data.document.table, response.data.document);
            }
            commit("abortMail", response.data.email);
            //   commit("workingOn", { set: false, id: mail.id, type: 'mail' });
        })

        // commit("abortMail", data);
        //data.status = "aborted";
        //TODO MF: data.status auf aborted setzen und anschließend in  die DB Schreiben
    }
}

// mutations
const mutations = {
    clean(state){
        state.kooi.id = 0
        state.kooi.internal_company_id = null;
    },
    updateKooiProfit(state, profit){
        state.kooi.total_profit = profit.total_profit;
        state.kooi.profit_parts = profit.profit_parts;
        state.kooi.writen_profit = profit.writen_profit;
    },
    setAgentProvisionPercentage(state, amount) {
        state.agent_provision_percentage = amount;
    },
    setPolicies(state, policies) {
        state.policies = policies;
    },
    markRebatesLoaded(state, status) {
        state.kooi.data.rebate_loaded = status;

    },
    setRebateStatus(state, status) {
        state.rebates_unchangeable = status;
    },
    setLockLogistics(state, status) {
        state.lockLogistics = status;
    },
    setRebates(state, rebates) {
        state.rebates = rebates;
    },
    switchEditMode(state, value) {
        state.edit = false;
    },
    externalRelations(state, data) {
        state.externalRelations = data;
    },
    workingOn(state, data) {
        if (data.set) {
            state.workingOn[data.type].push(data.id);
        } else {
            var index = state.workingOn[data.type].findIndex(item => item == data.id);
            state.workingOn[data.type].splice(index, 1);
        }
    },
    isSaving(state, data) {
        state.isSaving += data;
    },
    setExternalOrders(state, orders) {
        if (state.external.orders.clear == true) {
            state.external.orders.list = [];
            state.external.orders.page = 0;
        }
        state.external.orders.list.push(...orders);
        state.external.orders.clear = false;
        state.external.orders.loading = false;
    },
    setExternalOrdersSearch(state, search) {
        state.external.orders.loading = true;
        state.external.orders.search = search;
        state.external.orders.clear = true;
    },
    setExternalOrderSearchValue(state, value) {
        state.external.orders.search = value;
    },
    increasePageExternalOrders(state) {
        state.external.orders.loading = true;
        state.external.orders.page++;
    },
    updateUsers(state, user) {
        var index = state.presentUsers.findIndex(item => item.id == user.id);
        if (index >= 0) {
            state.presentUsers[index] = user;
        }
        else (
            state.presentUsers.unshift(user)
        )
    },
    newMail(state, mail) {
        state.tables.mails.unshift(mail);
    },
    updateMail(state, mail) {
        var index = state.tables.mails.findIndex(item => item.id == mail.id);
        if (index >= 0) {
            state.tables.mails[index] = mail;
        }
        else (
            state.tables.mails.unshift(mail)
        )
    },
    abortMail(state, mail) {
        var index = state.tables.mails.findIndex(item => item.id == mail.id);
        if (index >= 0) {
            state.tables.mails[index].status = "canceled";

        }
    },
    setUsers(state, users) {
        state.presentUsers = users;
    },
    removeUser(state, user) {
        var index = state.presentUsers.findIndex(item => item.id == user.id);
        if (index >= 0) {
            state.presentUsers.splice(index, 1);
        }
    },
    loadDocument(state, payload) {
        state.editDocument = payload.document;
    },
    loadRelease(state, payload) {
        state.editRelease = payload.release;
    },
    updateoffers(state, document) {
        var index = state.tables.offers.findIndex(item => item.id == document.id);
        if (index >= 0) {
            state.tables.offers[index] = document;
        }
        else (
            state.tables.offers.unshift(document)
        )
    },
    updateorders(state, document) {
        var index = state.tables.orders.findIndex(item => item.id == document.id);
        if (index >= 0) {
            state.tables.orders[index] = document;
        }
        else (
            state.tables.orders.unshift(document)
        )
    },
    updatereleases(state, document) {
        var index = state.tables.releases.findIndex(item => item.id == document.id);
        if (index >= 0) {
            state.tables.releases[index] = document;
        }
        else (
            state.tables.releases.unshift(document)
        )
    },
    updateinvoices(state, document) {
        var index = state.tables.invoices.findIndex(item => item.id == document.id);
        if (index >= 0) {
            state.tables.invoices[index] = document;
        }
        else (
            state.tables.invoices.unshift(document)
        )
    },
    updatePurchase(state, document) {
        var index = state.tables.purchases.findIndex(item => item.id == document.id);
        if (index >= 0) {
            state.tables.purchases[index] = document;
        }
        else (
            state.tables.purchases.unshift(document)
        )
    },
    updateReleases(state, document) {
        var index = state.tables.releases.findIndex(item => item.id == document.id);
        if (index >= 0) {
            state.tables.releases[index] = document;
        }
        else (
            state.tables.releases.unshift(document)
        )
    },
    pushOffers(state, offer) {
        var index = state.tables.offers.findIndex(item => item.id == offer.id);
        if (index <= -1) {
            state.tables.offers.unshift(offer);
        } else {
            state.tables.offers[index] = offer;
        }
    },

    pushOrder(state, order) {
        var index = state.tables.orders.findIndex(item => item.id == order.id);
        if (index <= -1) {
            state.tables.orders.unshift(order);
        } else {
            state.tables.orders[index] = order;
        }
    },
        pushInvoices(state, invoice) {
        var index = state.tables.invoices.findIndex(item => item.id == invoice.id);
        if (index > -1) {
            state.tables.invoices[index] = invoice;
        } else {
            state.tables.invoices.unshift(invoice);
        }
    },
    pushRelease(state, release) {
        var index = state.tables.releases.findIndex(item => item.id == release.id);
        if (index > -1) {
            state.tables.releases[index] = release;
        } else {
            state.tables.releases.unshift(release);

        }
    },
    pushMails(state, mail) {
        state.tables.mails.unshift(mail);
    },
    setOffers(state, offers) {
        state.tables.offers = offers;
    },
    setMails(state, mails) {
        state.tables.mails = mails;
    },
    setInvoices(state, invoices) {
        state.tables.invoices = invoices;
    },
    setPurchases(state, purchases){
        state.tables.purchases = purchases;
    },
    setReleases(state, releases) {
        state.tables.releases = releases;
    },
    setRelease(state, release) {
        state.release = release.document;
    },
    setOrders(state, orders) {
        state.tables.orders = orders;
    },
    destroyInvoice(state, invoice) {
        var index = state.tables.invoices.findIndex((item) => item.id == invoice.id)
        if (index > -1) {
            state.tables.invoices.splice(index, 1);
        }
    },
    destroyOrder(state, order) {
        var index = state.tables.orders.findIndex((item) => item.id == order.id)
        if (index > -1) {
            state.tables.orders.splice(index, 1);
        }
    },
    destroyRelease(state, release) {
        var index = state.tables.releases.findIndex((item) => item.id == release.id)
        if (index > -1) {
            state.tables.releases.splice(index, 1);
        }
    },
    destroyOffer(state, offer) {
        var index = state.tables.offers.findIndex((item) => item.id == offer.id)
        if (index > -1) {
            state.tables.offers.splice(index, 1);
        }
    },
    setOrder(state, order) {
        state.order = order.document;
    },
    pushKooi(state, kooi) {
        state.kooi = kooi;
    },
    loaded(state, status) {
        state.loaded.invoices = status;
        state.loaded.mails = status;
        state.loaded.offers = status;
        state.loaded.releases = status;
        state.loaded.orders = status;
        state.kooiloaded = status;
    },
    setKooi(state, kooi) {
        state.kooi = kooi;
    },
    setKooiStatus(state, status) {
        state.kooi.status = status;
    },
    setKooiId(state, id) {
        state.id = id;
        state.kooi.id = id;
    },
    setKooiSalesType(state, type) {
        state.kooi.sales_type = type;
    },
    setLogisticChain(state, id) {
        state.kooi.data = Object.assign(state.kooi.data ?? {}, { logistic_chain: id });
    },
    setBaseData(state, data) {
        state.kooi.data = Object.assign(state.kooi.data ?? {}, data);
    },
    setCompanyId(state, data) {
        state.kooi.data.company_id = data;
    },
    supplier(state, data) {
        state.supplier = data;
    },
    customer(state, data) {
        state.customer = data;
    },

    loadTabRelatedData(state, tab) {
        // lade beim tab order die order details aus dem store
        if (tab.name == "order") {
            if (state.order !== undefined && state.order != null) {
                state.editDocument = state.order;
            } else {
                state.editDocument = null;
            }
        }
        if (tab.name == "releases") {
            if (state.releases !== undefined && state.releases != null) {
                state.editRelease = state.releases;
            } else {
                state.editDocument = null;
            }
        }
    },
    setEMailTemplates(state, templates) {
        state.emailTemplates = templates;
    },
    updateColumn(state, data) {
        var index = state.displayColumns[data.type].findIndex(item => item.key == data.column.key)
        for (let i in state.displayColumns[data.type]) {
            state.displayColumns[data.type][i].direction_pos += 1;
        }
        if (index > -1) {
            state.displayColumns[data.type][index] = data.column;
            state.displayColumns[data.type][index].direction_pos = 0;
        }
    },
    kooiStatusResource(state, data) {

        state.kooi_status_resource = data;
    },
    resetMenuOptions(state) {
        for (let i in state.menuOptions) {
            for (let j in state.menuOptions[i]) {
                for (let k in state.menuOptions[i][j]) {
                    state.menuOptions[i][j][k].disabled = false;
                    state.menuOptions[i][j][k].loading = false;
                }
            }
        }
    },
    menuUpdate(state, data) {
        if (state.menuOptions && state.menuOptions[data.subkey] && state.menuOptions[data.subkey][data.filterStatus]) {
            var index = state.menuOptions[data.subkey][data.filterStatus].findIndex(item => item.key == data.menu.key);
            if (index > -1) {
                state.menuOptions[data.subkey][data.filterStatus][index][data.set] = data.status;
            }
        }
    },
    set_copy_data(state, data) {
        state.copy_data = data;
    },
    elementLoading(state, data) {
        if (state.elementsLoading[data.type]) {
            let index = state.elementsLoading[data.type].findIndex(item => item.id == data.id);
            if (index >= 0) {
                if (!state.elementsLoading[data.type][index].count) {
                    state.elementsLoading[data.type][index].count = 0;
                }
                state.elementsLoading[data.type][index].count++;
            } else {
                data.count = 1;
                state.elementsLoading[data.type].push(data);
            }
        }
    },
    elementLoadFinished(state, data) {
        if (state.elementsLoading[data.type]) {
            let index = state.elementsLoading[data.type].findIndex(item => item.id == data.id);
            if (index >= 0) {
                state.elementsLoading[data.type][index].count--;
            } else {
            }
        }
    },
    noElementLoading(state) {
        state.elementsLoading.invoices = [];
        state.elementsLoading.orders = [];
    },
    unlocked(state, timestamp){
        state.unlocked = timestamp;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        logistics,
        conditions,
        mycroftDocuments,
        upcomingEvents,
        log,
        commissions,
        shinkibaMain,
        payments,
    }
}
